//------------------------------------------------------------------------------
//
// OAIDC Settings
//
// Defines configuration for interacting with our SSO system based on the
// current URL.
//
//------------------------------------------------------------------------------

export const isNonProdEnv =
  window.location.hostname === 'localhost' ||
  window.location.hostname.includes('tst') ||
  window.location.hostname.includes('test') ||
  window.location.hostname.includes('.stg');

export const oidcRoot = isNonProdEnv
  ? 'https://beta-login.svc.tst.apnic.int'
  : 'https://login.apnic.net';
const client_id = isNonProdEnv
  ? '0oa3aawhorI3wrCMI0x7'
  : '0oa1fr49z6aHkpJ2p3l7';
const post_logout_redirect_uri = isNonProdEnv
  ? 'https://user-management.svc.tst.apnic.int/single-logout'
  : 'https://profile.apnic.net/single-logout';
let authority = `${oidcRoot}/oauth2/apnic`;

let response_type = 'code';

export const oidcSettings = {
  authority: authority,
  client_id: client_id,
  redirect_uri: window.location.origin + '/auth-callback',
  response_type: response_type,
  scope: 'openid email profile offline_access',
  automaticSilentRenew: true,
  silent_redirect_uri: window.location.origin + '/silent-renew-oidc.html',
  post_logout_redirect_uri: post_logout_redirect_uri
};
export const profileSectionURLs = isNonProdEnv
  ? {
      personalSettingsURL: 'https://user-management.svc.tst.apnic.int',
      passwordSecurityURL:
        'https://user-management.svc.tst.apnic.int/password-security',
      myApnicDashboardURL: 'https://myapnic-portal.svc.tst.apnic.int',
      linkExistingMembership:
        'https://myapnic-facade.svc.tst.apnic.int/auth/nm-landing-page.html',
      membershipApplication: 'https://membership-application.svc.tst.apnic.int'
    }
  : {
      personalSettingsURL: 'https://profile.apnic.net',
      passwordSecurityURL: 'https://profile.apnic.net/password-security',
      myApnicDashboardURL: 'https://my.apnic.net',
      linkExistingMembership:
        'https://resources.apnic.net/auth/nm-landing-page.html',
      membershipApplication: 'https://www.apnic.net/get-ip/apnic-membership'
    };
